import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import Constants from "../../../../common/Constants";
import ItemService from "../../../../services/commonService";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import QRCode from "react-qr-code";
import Navbar from "react-bootstrap/Navbar";
import {
  getJobcardReportFooter,
  loadJobcardRevisingMetadata,
  REVISING_REPORT_TYPES,
  loadSizeMasterByCode,
} from "../../../../common/JobcardPrintUtils";
const moment = require("moment");

const ViewJobcardCode = (props) => {
  // const dispatch = useDispatch();
  const [deptDataBySizeCode, setDeptDataBySizeCode] = useState({});
  const [sizeMasterByCode, setSizeMasterByCode] = useState({});
  const [revisingMetadata, setRevisingMetadata] = useState({});

  const loadDepartmentLists = async (jobcards) => {
    const sizeCodes = [
      ...new Set(jobcards.map((item) => item?.sizeCode).filter(Boolean)),
    ];
    const processEntries = await Promise.all(
      sizeCodes.map(async (sizeCode) => {
        const item = await ItemService.getProcessMasterListDataById({
          id: sizeCode,
        });

        return [
          sizeCode,
          item?.status === 200 ? item?.data?.[0]?.process || [] : [],
        ];
      }),
    );

    setDeptDataBySizeCode(Object.fromEntries(processEntries));
  };

  useEffect(() => {
    if (props?.selectedItems?.length > 0) {
      Promise.all([
        loadDepartmentLists(props.selectedItems),
        loadSizeMasterByCode(props.selectedItems).then(setSizeMasterByCode),
        loadJobcardRevisingMetadata(
          props.selectedItems,
          REVISING_REPORT_TYPES.BATCH_REPORT,
        ).then(setRevisingMetadata),
      ]).catch((error) => {
        console.error("Error loading job card print data:", error);
      });
    } else {
      setDeptDataBySizeCode({});
      setSizeMasterByCode({});
      setRevisingMetadata({});
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  function applyPrintStyles() {
    const style = document.createElement("style");
    style.textContent = ``;
    document.head.appendChild(style);
  }

  window.onbeforeprint = applyPrintStyles;

  const printModalContent = () => {
    const printWindow = window.open("", "", "height=842,width=1295");
    const modalContent = document.getElementById("printable-area").innerHTML;

    printWindow.document.write("<html><head><title>Print</title>");
    printWindow.document.write(
      '<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">'
    );
    printWindow.document.write("<style>");
    printWindow.document.write(`
      @media print {
        /* Add general page margin to add space around the content */
        @page {
          size: A4 portrait;  /* Ensure the page size is A4 in portrait mode */
          margin: 1in;  /* Set a 1-inch margin around the entire page (can be adjusted) */
        }

        /* Table Styling */
        table.jobcard-content-table {
          width: 100%; /* Ensure the table takes up full width */
          border-collapse: collapse; /* Collapse the table borders */
          page-break-before: always; /* Force a page break before this table */
          padding: 10px; /* Add padding inside the table */
        }
          .jobcard-content-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }

        .telma-header {
          text-align: center;
          text-decoration: underline;
        }
          .telma-detail {
            display:block;
            text-align: center;
            width:100%;
          }
            .jobcard-singlerow {
            text-align: center !important;
          }

        table.jobcard-content-table td, table.jobcard-content-table th {
          border: 2px solid #000000; /* Add borders to the table cells */
          padding: 5px 8px; /* Padding inside the cells to give some space */
          text-align: left; /* Align text to the left */
        }

        /* QR Code cell (with rowspan) styling */
        .qr-code-cell {
          padding: 10px; /* Padding inside the QR code cell */
          text-align: center; /* Center the QR code */
          vertical-align: middle; /* Center QR code vertically */
        }

        /* Styling for text content and card content */
        .card-body {
          padding: 20px; /* Add padding inside the card body */
        }

        /* Prevent content from breaking into multiple pages */
        table.jobcard-content-table tr {
          page-break-inside: avoid; /* Prevent rows from breaking across pages */
        }

        .jobcard-detail-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed; /* Equal column widths */
          font-size: 11px;
          th, td {
            border: 2px solid #000;
            padding: 8px;
            word-wrap: break-word;
            text-align: left;
            height:50px;
          }
          th:first-child,
          td:first-child {
            width: 16%; /* First column gets more space */
          }

          th:not(:first-child),
          td:not(:first-child) {
            width: 10%; /* Adjust based on how many columns you have */
          }
        }

        /* Job card content */
        .jobcard-content-bold {
          font-weight: bold;
        }

        /* Additional spacing between the QR code and text */
        .jobcard-qr-code {
          padding: 5px; /* Add padding around the QR code */
        }

        /* Add padding to any text elements inside the table */
        .jobcard-title-content, .jobcard-priority, .jobcard-content-bold {
          padding-bottom: 2px; /* Provide some space between lines of text */
        }

        /* Add spacing between the rows of the table */
        tr + tr {
          margin-top: 10mm; /* Adds space between each row */
        }
        
        /* Add space around the body content */
        body {
          padding: 20px; /* Padding around the entire page content */
          margin: 0;
        }

          .jobcard-qr-code {
          display: flex; /* Use flexbox to center content */
          justify-content: center; /* Center horizontally */
          align-items: center; /* Center vertically */
          width: 100%; /* Ensure the QR code container takes full width */
          height: auto; /* Adjust the height based on content */
          padding: 5px; /* Optional: Add some padding around the QR code */
          margin: 0 auto; /* Center the QR code container in the page */
        }

        /* You can also set a fixed size for QR code to make sure it scales well */
        .qr-code {
          max-width: 120px; /* Max width of the QR code */
          width: 100%; /* Make sure the QR code fits inside its container */
          height: auto; /* Maintain aspect ratio */
        }
          .jobcard-priority {
          color: #0047ab !important; /* Default priority color */
          text-align: center;
          font-weight:bold !important;
        }

        .jobcard-priority-urgent {
          color: red !important; /* Priority 'urgent' color */
          text-align: center;
          font-weight:bold;
          font-weight:bold !important;
        }

        .jobcard-title-content {
          text-align: center !important;
          font-weight: bold;
          color: #0047ab;
          margin-bottom:2px;
        }

        .jobcard-title-content-jobcard {
          margin-top:10px;
          text-align: center !important;
          font-weight: bold;
          color: #0047ab;
        }
      }

    `);
    printWindow.document.write("</style>");
    printWindow.document.write("</head><body>");
    printWindow.document.write(modalContent);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-90w">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          View All QR Codes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="qr-code">
        <Navbar expand="lg" className="qr-code-navbar">
          <Button
            class="accordion-button"
            type="button"
            variant="primary"
            onClick={printModalContent}
          >
            <i className="bi bi-printer"></i> {"Print"}
          </Button>
        </Navbar>
        <div id="printable-area">
          <Row>
            {props.selectedItems.map((value, index) => (
              <>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  key={index}
                  className="mb-4"
                >
                  <table className="jobcard-content-table">
                    <thead>
                      <th colSpan="5">
                        <h4 className="telma-header">
                          TELMA MICRO NEEDLES PVT LTD
                        </h4>
                        <span className="telma-detail">
                          NO-56/6, MAJARA HOSAHALLI MAIN ROAD, DODDABALLAPURA
                          INDUSTRIAL AREA, BANGALORE-561203
                        </span>
                      </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          className="jobcard-content-bold"
                          style={{ width: "20%" }}
                        >
                          Size :{" "}
                        </td>
                        <td>{value.sizeCode}</td>
                        <td className="jobcard-content-bold">
                          Required Date :
                        </td>
                        <td>{value.requiredDate}</td>
                        <td
                          className="qr-code-cell"
                          rowSpan="6"
                          style={{ width: "20%" }}
                        >
                          <Card.Title
                            className={
                              value.priority === "urgent"
                                ? "jobcard-priority-urgent"
                                : "jobcard-priority"
                            }
                          >
                            {value.priority.toUpperCase()}
                          </Card.Title>
                          <Card.Text className="jobcard-title-content">
                            {`${value.siliconize}`}
                          </Card.Text>
                          <span className="jobcard-qr-code">
                            <QRCode size={115} value={value.jobcard} />
                          </span>
                          <Card.Text className="jobcard-title-content-jobcard">
                            {value.jobcard}
                          </Card.Text>
                        </td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Batch No. :</td>
                        <td>{value.batch}</td>
                        <td className="jobcard-content-bold">Plan :</td>
                        <td>{moment(value.plan).format("MMM-YYYY")}</td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Batch Qty :</td>
                        <td>{parseInt(value.originalQuantityPerJobCard)}</td>
                        <td className="jobcard-content-bold">Plan Type :</td>
                        <td>{value.planType}</td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Batch Dozens :</td>
                        <td>{value.batchTotalQtyDozen}</td>
                        <td className="jobcard-content-bold">Customer :</td>
                        <td>{value.customerCode}</td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Wire Trace Number :</td>
                        <td>{value.materialTraceNumber || "-"}</td>
                        <td className="jobcard-content-bold">Weight in Grams :</td>
                        <td>
                          {sizeMasterByCode[value.sizeCode]?.weightInGrams ?? "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Remarks :</td>
                        <td colSpan="3">{value.remarks}</td>
                      </tr>
                      <tr>
                        <td
                          className="jobcard-content-bold jobcard-singlerow"
                          colSpan="5"
                        >
                          PRODUCTION DATA SHEET
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="jobcard-detail-table mt-1">
                    <thead>
                      <tr>
                        <th>DEPARTMENT</th>
                        <th>DATE</th>
                        <th>OPERATOR</th>
                        <th>QTY NOS</th>
                        {/* <th>GRAMS</th> */}
                        <th>MC.NO</th>
                        <th>START TIME</th>
                        <th>END TIME</th>
                        {/* <th>MAT CONSP</th>` */}
                        <th>TL/SUPR</th>
                        <th>CM.NO</th>
                        <th>REMARKS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deptDataBySizeCode[value.sizeCode]?.map((val, index) => (
                        <tr key={index}>
                          <td>{val.deptName}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          {/* <td></td> */}
                          <td></td>
                          <td></td>
                          <td></td>
                          {/* <td></td> */}
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
                {(() => {
                  const footer = getJobcardReportFooter({
                    sizeMasterByCode,
                    sizeCode: value.sizeCode,
                    jobcard: value.jobcard,
                    revisingMetadata,
                  });

                  return (
                    <>
                      <Col xs={12} sm={6} md={6} lg={6} className="">
                        {footer.reportTitle}
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3} className="">
                        Rev No: {footer.reviseNumber}
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3} className=" text-end">
                        Date: {footer.reviseDate}
                      </Col>
                    </>
                  );
                })()}
              </>

              // <Col xs={12} sm={6} md={4} lg={3} key={index} className="mb-4">
              //   <Card className="my-3">
              //     <Row>
              //       <Col md={5}>
              //         <Card.Title className={`${value.priority === 'urgent' ? "jobcard-priority-urgent" : "jobcard-priority"}`}>{value.priority.toUpperCase()}</Card.Title>
              //         <Card.Text className="jobcard-title-content">
              //           {`${value.siliconize}`}
              //         </Card.Text>
              //         <span className="jobcard-qr-code d-flex justify-content-center align-items-center">
              //           <QRCode size={160} value={value.jobcard} />
              //         </span>
              //       </Col>
              //       <Col md={7}>
              //         <Card.Body>
              //           <Card.Text className="jobcard-content-bold">
              //             {`Size : ${value.sizeCode}`}
              //           </Card.Text>
              //           <Card.Text className="jobcard-content-bold">
              //             {`B.C No : ${value.batch}`}
              //           </Card.Text>
              //           <Card.Text className="jobcard-content-bold">
              //             {`S.C No : ${index + 1} / ${props.selectedItems.length}`}
              //           </Card.Text>
              //           <Card.Text className="jobcard-content-bold">
              //             {`S.T Qty : ${value.quantityPerJobCard}`}
              //           </Card.Text  >
              //           <Card.Text className="jobcard-content">
              //             {`Customer : ${value.customerCode}`}
              //           </Card.Text>
              //           <Card.Text className="jobcard-content">
              //             {`Required Date :  ${value.requiredDate}`}
              //           </Card.Text>
              //           <Card.Text className="jobcard-content">
              //             {`Plan :  ${value.plan}`}
              //           </Card.Text>
              //           <Card.Text className="jobcard-content">
              //             {`Remarks :  ${value.remarks}`}
              //           </Card.Text>
              //         </Card.Body>
              //       </Col>
              //     </Row>
              //   </Card>
              // </Col>
            ))}
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ViewJobcardCode;
